// The wallboard device token lives in the TV's localStorage — it is the only
// credential on an unlocked display (deliberately NOT a session cookie, so
// the authorising admin is never left signed in on the device). Key is
// per-subdomain so one browser profile can hold tokens for several tenants.
const storageKey = () => {
  const subdomain = window.location.hostname.split('.')[0]
  return `ambunet.wallboard.${subdomain}`
}

export const getWallboardToken = () => {
  try {
    return localStorage.getItem(storageKey())
  } catch {
    return null
  }
}

export const setWallboardToken = (token) => {
  try {
    localStorage.setItem(storageKey(), token)
  } catch {
    // Private windows etc. — the display still works for this page load
  }
}

export const clearWallboardToken = () => {
  try {
    localStorage.removeItem(storageKey())
  } catch {
    /* ignore */
  }
}

// Per-device theme override from the display's own toggle — beats the board's
// configured theme on this screen only
const themeKey = () => `${storageKey()}.theme`

export const getWallboardThemeOverride = () => {
  try {
    const value = localStorage.getItem(themeKey())
    return value === 'light' || value === 'dark' ? value : null
  } catch {
    return null
  }
}

export const setWallboardThemeOverride = (mode) => {
  try {
    localStorage.setItem(themeKey(), mode)
  } catch {
    /* ignore */
  }
}
